import { useState } from "react";
import ReactQuill from "react-quill-new";
import { Card, CardBody, Col, Row } from "reactstrap";
import { bubbleThemeContent } from "../../../../Data/Miscellaneous/Editor";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { BubbleThemeTitle } from "../../../../Utils/Constants";

export default function BubbleTheme() {
  const [value, setValue] = useState(bubbleThemeContent);

  return (
    <Row>
      <Col sm={12}>
        <Card>
          <CommonCardHeader title={BubbleThemeTitle} />
          <CardBody>
            <ReactQuill theme="bubble" value={value} onChange={setValue} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
